import React from 'react';
import './styles.css';

export const ParrafoEquipo = () => {
  return (
    <>
        <div className='EquipoPage-Parrafo'>
                Somos un equipo joven de maestras y técnicos especializado en 
                educación infantil pero con una experiencia de más de 
                <span className='EquipoPage-textoResaltado'> 10 años dentro del sector de la enseñanza.</span>
        </div>
    </>
  )
}
